// extracted by mini-css-extract-plugin
module.exports = {"pause":"styles_pause__jdRf4","play":"styles_play__TxY7g","play-animation":"styles_play-animation__6Lt_R"};